import { Lexer, type Marked, type Token } from 'marked';

/**
 * Lex `text` as INLINE markdown only — no block constructs.
 *
 * Label surfaces (names, roles, titles, breadcrumbs) ran through the block
 * lexer, which reads a perfectly ordinary model-authored title like
 * `1. Introduction` as an ordered LIST, `# Summary` as an H1, and `- Draft` as
 * a bullet. In a one-line name row that is never what the author meant, and it
 * is the mirror of the bug this whole pass exists to fix: there, markdown
 * rendered as literal text; here, literal text renders as markdown.
 *
 * Inline lexing keeps everything a label legitimately wants — emphasis, code,
 * links, and `[[…]]` references — while leaving list/heading/blockquote
 * punctuation as the literal text it was.
 *
 * Kept free of React and `@/` imports so the assertions can load it directly.
 */
export function lexInlineTokens(input: {
  markdownParser: Marked;
  text: string;
}): Token[] {
  return Lexer.lexInline(input.text, input.markdownParser.defaults);
}
